import styled from 'styled-components';
import BREAKPOINTS from '../../constants/breakpoints';

export const Box = styled.div`
  margin: 0 auto;
  padding: 60px 4rem 60px;
  max-width: ${BREAKPOINTS.FULL}px;
`;
